import React, { MouseEventHandler, useRef } from 'react';
import componentProps from '../../../helpers/componentProps';
import { scrollToElement } from '../../../helpers/scroll';
import { useSticky } from '../../../hooks/useSticky';
import { applyComponentTheme } from '../../../theme';
import { InPageNavProps } from '../types';
import { useActiveSection } from '../useActiveSection';
import NavItemDesktop from './NavItemDesktop';
import {
  IN_PAGE_NAV_TOP_IN_PX,
  InPageNavContainer,
  Nav,
  NavHeading,
  NavText,
} from './styles';

const onNavItemClick = (id: string): MouseEventHandler => (event) => {
  event.preventDefault();
  scrollToElement(id, IN_PAGE_NAV_TOP_IN_PX);
};

const InPageNavDesktop: React.FC<InPageNavProps> = ({
  navHeading,
  navSections,
  ...props
}) => {
  const sectionIds = navSections.map((section) => section.id);

  const navRef = useRef<HTMLDivElement>(null);
  useSticky(navRef);
  const activeSectionId = useActiveSection(sectionIds, navRef, 'top');
  return (
    <InPageNavContainer {...componentProps(props)}>
      <Nav ref={navRef} aria-label={`${navHeading} desktop in-page nav`}>
        <NavHeading>{navHeading}</NavHeading>
        {navSections.map(({ text, id }) => (
          <NavItemDesktop
            key={id}
            onClick={onNavItemClick(id)}
            href={encodeURI(`#${id}`)}
            active={activeSectionId === id}>
            <NavText>{text}</NavText>
          </NavItemDesktop>
        ))}
      </Nav>
    </InPageNavContainer>
  );
};

export default applyComponentTheme(InPageNavDesktop, 'InPageNavDesktop');
